import React from 'react';
import { Link as ReactRouterDomLink, LinkProps as ReactRouterDomLinkProps } from 'react-router-dom';

// Reason for this intermediate component: https://material-ui.com/guides/composition/#routing-libraries
const RouterLink = React.forwardRef<HTMLAnchorElement, ReactRouterDomLinkProps>((props, ref) => (
  <ReactRouterDomLink innerRef={ref} {...props} />
));

export default RouterLink;
